// extracted by mini-css-extract-plugin
export default {"tabVars":"Tab_dark_tabVars__RzhF9"};